import React from "react";
import { useParams } from "react-router-dom";
import { useProgressData } from "../../hooks/useProgressData";
import ProgressOverview from "./ProgressOverview";
import ProgressTable from "./ProgressTable";

const DashboardMonitoring: React.FC = () => {
  const { id: projectId, sectionId } = useParams<{ id: string; sectionId: string }>();
  const progressData = useProgressData(projectId, sectionId);

  return (
    <div className="grid gap-4">
      <ProgressOverview
        totals={progressData.totals}
        remaining={progressData.remaining}
        overallPct={progressData.overallPct}
        actualPct={progressData.actualPct}
        remainingPct={progressData.remainingPct}
        devPct={progressData.devPct}
        isLoading={progressData.isLoading}
      />
      <ProgressTable rows={progressData.rows} isLoading={progressData.isLoading} />
    </div>
  );
};

export default DashboardMonitoring;
